const MINUS = '−'; // proper minus sign U+2212, not hyphen-minus
const EN_DASH = '–';

const isFiniteNumber = (n: unknown): n is number => typeof n === 'number' && Number.isFinite(n);

const formatOneDecimal = (n: number): string => {
  // Centered "OK" bucket bounds (±0.25) need two decimals so they
  // don't render as ±0.3. Everything else uses one decimal.
  const abs = Math.abs(n);
  if (abs > 0 && abs < 1 && (abs * 100) % 10 !== 0) {
    return abs.toFixed(2);
  }
  return abs.toFixed(1);
};

const withSign = (n: number): string => {
  const body = formatOneDecimal(n);
  return n < 0 ? `${MINUS}${body}` : `${body}`;
};

export const formatSignedRt = (diff: number | null | undefined): string | null => {
  if (!isFiniteNumber(diff)) return null;
  return withSign(diff);
};

export const formatDiffRange = (min: number, max: number): string => {
  if (max === Number.MAX_VALUE) {
    return `≥ ${withSign(min)}`;
  }
  if (min === -Number.MAX_VALUE) {
    return `< ${withSign(max)}`;
  }
  return `${withSign(min)} ${EN_DASH} ${withSign(max)}`;
};
